@for (top of topTenRandom(); track top.order) {
  <div class="row d-none d-lg-block">
    <div class="col-12">
      <h3 class="mb-2 dark-blue-text text-center mb-3">
        {{ "top_10" | translate }} | {{ top?.label?.language?.title }}
      </h3>
      <div class="box">
        <div class="item-profile-little">
          <div class="item-tittle linea mb-1">
            <img
              height="25px"
              [src]="top?.data?.icon_marker_category | cdnUrl: 100 : true"
            /><a routerLink="geomarker/{{ top?.data?.slug }}" class="a-nostyle">
              {{ top?.data?.language?.name }}</a
            >
          </div>
          <app-rating
            class="d-block my-1"
            [disabled]="true"
            [qualification]="top?.data?.valuations || 0"
          />
          <app-valoration
            class="d-block my-1"
            [valuations]="top?.data?.valuations || 0"
          />
          <div class="item-image mb-2">
            <img [lazyLoad]="top?.data?.image | cdnUrl: 300 : true" />
          </div>
          <div class="item-description mb-3">
            {{ top?.data?.language?.short_description }}
          </div>
          <a
            (click)="goToTopten(top?.label?.language?.title || '')"
            class="button success full"
            >VER TOP</a
          >
        </div>
      </div>
    </div>
  </div>
}
